"use client";

import { useState } from "react";
import Icon from "@/components/Icon";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { Issue } from "../constants";
import { RoadmapModal } from "./RoadmapModal";

export const RoadmapCard = ({ issue }: { issue: Issue }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const isBug = issue.labels.nodes.some(
		(label) => label.name.toLowerCase() === "bug",
	);

	const handleOpenChange = (open: boolean) => {
		setIsModalOpen(open);
	};

	return (
		<>
			<Card
				className="cursor-pointer transition-shadow hover:shadow-md"
				onClick={() => handleOpenChange(true)}
			>
				<CardHeader>
					<div className="w-fit">
						<Badge
							variant="outline"
							className={cn(
								"flex items-center gap-1 border-blue-200 text-sm",
								{
									"bg-blue-50 text-blue-700": !isBug,
								},
								{
									"border-red-200 bg-red-50 text-red-700": isBug,
								},
							)}
						>
							{isBug ? (
								<>
									<Icon name="TriangleAlert" className="size-4" />
									Bug
								</>
							) : (
								<>
									<Icon name="Zap" className="size-4" />
									Feature
								</>
							)}
						</Badge>
					</div>
					<CardTitle className="mt-2 text-xl">{issue.title}</CardTitle>
					{issue.description && (
						<div className="mt-2 line-clamp-2">{issue.previewMDX}</div>
					)}
					<div className="mt-4 flex flex-wrap gap-2">
						{issue.labels.nodes.map((label) => {
							if (
								["roadmap", "bug", "feature"].includes(label.name.toLowerCase())
							) {
								return "";
							}

							return (
								<Badge
									key={label.name}
									variant="outline"
									className="border-gray-200 bg-gray-50 text-gray-700 text-xs"
									style={{
										borderColor: label.color,
										backgroundColor: `${label.color}20`,
										color: label.color,
									}}
								>
									{label.name}
								</Badge>
							);
						})}
					</div>
				</CardHeader>
			</Card>
			<RoadmapModal
				title={issue.title}
				open={isModalOpen}
				handleOpenChange={handleOpenChange}
			>
				{issue.description && (
					<div className="prose mt-4 max-h-[60vh] max-w-none overflow-y-auto pr-4">
						{issue.preRenderedMDX}
					</div>
				)}
			</RoadmapModal>
		</>
	);
};
